"use client"

import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { useMediaQuery } from "@/hooks/useMediaQuery"
import { PropsWithChildren, useState } from "react"
import SupporterTable, { Supporter } from "./SupporterTable"
import AvatarGroup from "@/app/components/Avatar/Group/AvatarGroup"

type Props = PropsWithChildren<{
  total: number
  supporters: Supporter[]
}>

export default function SupportersDialogDrawer({ total, supporters }: Props) {
  const [open, setOpen] = useState(false)
  const isDesktop = useMediaQuery("(min-width: 640px)")
  const avatars = supporters.map((s) => s.avatar).filter((_, i) => i < 3)
  const title = `${total} supporters`

  if (isDesktop) {
    return (
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger className="flex items-center">
          <AvatarGroup
            avatars={avatars}
            text={title}
            textClassName="pointer-events-none truncate"
          />
        </DialogTrigger>
        <DialogContent>
          <DialogHeader className="mb-2">
            <DialogTitle className="font-header text-foreground text-2xl">
              {title}
            </DialogTitle>
          </DialogHeader>
          <div className="max-h-[360px] overflow-auto">
            <SupporterTable supporters={supporters} />
          </div>
        </DialogContent>
      </Dialog>
    )
  }

  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger className="flex items-center">
        <AvatarGroup
          avatars={avatars}
          text={title}
          textClassName="pointer-events-none truncate"
        />
      </DrawerTrigger>
      <DrawerContent className="px-2">
        <DrawerHeader className="px-4 pt-4 pb-2">
          <DrawerTitle className="font-header text-foreground text-xl text-left">
            {title}
          </DrawerTitle>
        </DrawerHeader>
        <div className="max-h-[360px] mx-auto w-full">
          <SupporterTable isMinimal supporters={supporters} />
        </div>
      </DrawerContent>
    </Drawer>
  )
}
